import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../axiosInterceptor';

export type StudentDetailResponse = {
  user_id: string;
  name: string;
  avatar: string;
  email: string;
  phone: string;
  about: string;
  status: string;
  focus_area: string;
  goals: string[];
  sessions_attended: number;
  sessions_missed: number;
  resources: unknown[] | null;
  notes?: unknown[] | null;
};

type StudentDetailState = {
  loading: boolean;
  data: StudentDetailResponse | null;
  error: boolean;
};

const initialState: StudentDetailState = {
  loading: false,
  data: null,
  error: false,
};

export const getStudentDetail = createAsyncThunk<
  StudentDetailResponse,
  string
>('getStudentDetail', async (studentId) => {
  const { data } = await axios.get(
    `/api/coaches/me/students/${studentId}`
  );
  if (data?.response) {
    return data.response as StudentDetailResponse;
  }
  return data as StudentDetailResponse;
});

const getStudentDetailSlice = createSlice({
  name: 'getStudentDetail',
  initialState,
  reducers: {
    resetDetail: (state) => {
      state.loading = false;
      state.data = null;
      state.error = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStudentDetail.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getStudentDetail.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(getStudentDetail.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export const { resetDetail } = getStudentDetailSlice.actions;
export default getStudentDetailSlice.reducer;
